// src/components/RelatedProducts.jsx
import React, { useContext, useEffect, useState } from 'react';
import { ShopContext } from "../context/ShopContext.jsx";
import { Box, Typography } from '@mui/material';
import ProductItem from "./ProductItem.jsx";

const RelatedProducts = ({ category, subCategory }) => {
  const { products, productData } = useContext(ShopContext);
  const [related, setRelated] = useState([]);

  useEffect(() => {
    if (Array.isArray(products) && productData && category) {
      const filteredProducts = products
        .filter(
          (p) =>
            p.category === category &&
            p.subCategory === subCategory &&
            p.id !== productData.id
        )
        .slice(0, 4); // Show 4 related products
      setRelated(filteredProducts);
    }
  }, [products, productData, category, subCategory]);

  if (related.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mt: 8 }}>
      <Typography variant="h4" component="h2" fontWeight="bold" gutterBottom>
        Related Products
      </Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: 'repeat(auto-fill, minmax(200px, 1fr))', // Use auto-fill for better responsiveness
            sm: 'repeat(auto-fill, minmax(220px, 1fr))',
            md: 'repeat(4, 1fr)',
          },
          gap: 3, // Consistent gap
        }}
      >
        {related.map((item) => (
          <ProductItem key={item.id} product={item} />
        ))}
      </Box>
    </Box>
  );
};

export default RelatedProducts;
